
import {
    GET_TERMINALSLIST_LOADING,
  GET_TERMINALSLIST_SUCCESS,
  GET_TERMINALSLIST_FAILED,
  } from "../types";
  
  const initialState = {
    terminals: null,
    loading: null,
    error: null,
  };
  
  export const getTerminalsListReducer = (
    state = initialState,
    action: { type: any; loading: any; payload: any; error: any }
  ) => {
    switch (action.type) {
      case GET_TERMINALSLIST_LOADING:
        return {
          ...state,
          loading: action.loading,
          error: null,
        };
      case GET_TERMINALSLIST_SUCCESS:
        return {
          ...state,
          loading: false,
          error: null,
          terminals: action.payload,
        };
      case GET_TERMINALSLIST_FAILED:
        return {
          ...state,
          loading: false,
          error: action.error,
        };
  
      default:
        return state;
    }
  };
  